import { commonService } from '.';
import axios from "axios";
// postAsync
const APIURL = process.env.PUBLIC_URL + "/api";

const getEaDetails = (body) => {
  return commonService.getWithParam('Ea/details', body);
};
const getYears = (body) => {
  return commonService.getWithParam('Ea/years', body);
}

const updateEaStatus = (id, action) => {
  return commonService.put('Ea/status?id=' + id + '&action=' + action, null);
};

const getStatusName = (id, idLang = 1) => {
  return commonService.getWithParam('Ea/status?id=' + id + '&idLang=' + idLang, null);
};

const downloadEA = (body) => {
  return commonService.getWithParam('SpireDoc/downLoadEA', body);
};

const managerSigned = (idEa) => {
  return commonService.put('Ea/managerSigned?idEa=' + idEa, null);
}

const sendMailEEP = (body, idLang) => {
  return commonService.post('Ea/sendEmailEEP?idLang=' + idLang, body);
}

const updateEaAsync = async (body) => {
  const endpoint = 'Ea/save';
  const url = `${APIURL}/` + endpoint;
  return await axios.post(url, body);
};

const updateEepBM = (body) => {
  return commonService.post('Ea/saveEepBM', body);
};

const downLoadEEPBM = async (file, request) => {
  let idUser = request.idUser;
  let year = request.year;
  let idLang = request.idLang;
  let idBusinessManager = request.idBusinessManager;
  const endpoint = 'SpireDoc/downLoadEEPBM?idBusinessManager=' + idBusinessManager + '&idUser=' + idUser + '&year=' + year + '&idLang=' + idLang;
  const url = `${APIURL}/` + endpoint;
  return await axios.post(url, file);
};

const getPJ = (idEa) => {
  return commonService.getWithParam('Ea/PJ?idEa=' + idEa, null);
};

const getFile = (idEa, idFile) => {
  return commonService.getWithParam('Ea/getFile?idEa=' + idEa + '&idFile=' + idFile, null);
};

const deleteFile = (idEa, idFile) => {
  return commonService.deleteWithParam('Ea/deleteFile?idEa=' + idEa + '&idFile=' + idFile, null);
};

const addFile = (body, idEa) => {
  return commonService.post('Ea/addFile?idEa=' + idEa, body);
};

const updateEAFiles = (body, idEa) => {
  return commonService.put('Ea/updateEAFiles?idEa=' + idEa, body);
};

const changeEEPYear = (body) => {
  let deadline = body.deadline;
  let year = body.year;
  let yearOld = body.yearOld;
  let userId = body.userId;
  return commonService.put('Ea/changeEEPYear?deadline=' + deadline + '&year=' + year + '&yearOld=' + yearOld + '&userId=' + userId, body);
};

const getEaYears = (idUser) => {
  return commonService.getWithParam('Ea/eaYears?idUser=' + idUser, null);
}

export const eaService = {
  getEaDetails,
  getYears,
  updateEaStatus,
  getStatusName,
  downloadEA,
  managerSigned,
  sendMailEEP,
  updateEaAsync,
  updateEepBM,
  downLoadEEPBM,
  getPJ,
  getFile,
  deleteFile,
  addFile,
  updateEAFiles,
  changeEEPYear,
  getEaYears
};
